module.exports = __webpack_public_path__ + "8b871cd8d90bb59247cddc0f6910e383.pdf";